import { createAction } from '@wix/communities-blog-client-common';

export const POST_PAGE_MORE_BUTTON_OPTION_CLICKED = 'postPageMoreButtonOption/CLICKED';

export const postPageMoreButtonOptionClicked = createAction(POST_PAGE_MORE_BUTTON_OPTION_CLICKED);
